import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
   {
    path: '/',
    name: 'dashboard', 
    component: require('../components/Home/Dashboard').default,
    meta: {
    forUsers: true
    }
  },
  {
    path: '/dashboard',
    name: 'home_dashboard', 
    component: require('../components/Home/Dashboard').default,
    meta: {
    forUsers: true
    
    }
  },
  {
    path: '/checkin',
    name: 'checkin', 
    component: require('../components/Home/CheckIn').default,
    meta: {
    forUsers: true
    
    }
  },
  {
  path: '/login',
  name: 'login',
  component: require('../components/Login').default,
  meta: {
    forGuests: true
  }
  },

  //User Routes
  { 
  path: '/users',
  name: 'users', 
  component: require('../components/Users/Index').default,
  meta: {
    forUsers: true,
    breadcrumbs: [
      {
        text: 'Dashboard',
        disabled: false,
        href: '/'
      },
      {
        text: 'Users',
        disabled: true,
        href: '/users'
      },
    ],
    
    }
  },
  { 
    path: '/addUser',
    name: 'addUser', 
    component: require('../components/Users/Create').default,
    meta: {
      forUsers: true,
      permission: 'read-booking',
      breadcrumbs:[
      {
        text:'Dashboard',
        disabled:false,
        href:"/",
      },
      {
        text:'Users',
        disabled:false,
        href:'/users',
      },
      {
        text: 'Add Visitor',
        disabled: true,
        href: '/addUser'
      }
      ]
    }
  },
  { 
    path: '/users/:id',
    name: 'showUserDetails', 
    component: require('../components/Users/Detail').default,
    meta: {
      forUsers: true,
      permission: 'read-user',
      breadcrumbs:[
      {
        text:'Dashboard',
        disabled:false,
        href:"/",
      },
      {
        text:'Users',
        disabled:false,
        href:'/users',
      },
      {
        text: 'User Details',
        disabled: true,
        href: '/users/:id'
      }
      ]
    }
  },
  { 
  path: '/users/edit/:id',
  name: 'editUser', 
  component: require('../components/Users/Edit').default,
  meta: {
    forUsers: true,
    breadcrumbs:[
    {
      text:'Dashboard',
      disabled:false,
      href:'/'
    },
    {
        text: 'Users',
        disabled: false,
        href: '/users'
    },
    {
        text: 'Edit User',
        disabled: true,
    },

    ]
    
  }
  },
  //Visitor Routes
  { 
  path: '/visitors',
  name: 'visitors', 
  component: require('../components/Visitors/Index').default,
  meta: {
    forUsers: true,
    breadcrumbs: [
      {
        text: 'Dashboard',
        disabled: false,
        href: '/'
      },
      {
        text: 'Visitors',
        disabled: true,
        href: '/visitors'
      },
    ],
    
    }
  },
  { 
    path: '/addVisitor',
    name: 'addVisitor', 
    component: require('../components/Visitors/Create').default,
    meta: {
      forUsers: true,
      permission: 'read-booking',
      breadcrumbs:[
      {
        text:'Dashboard',
        disabled:false,
        href:"/",
      },
      {
        text:'Visitors',
        disabled:false,
        href:'/visitors',
      },
      {
        text: 'Add Visitor',
        disabled: true,
        href: '/addVisitor'
      }
      ]
    }
  },
  { 
    path: '/visitors/:id',
    name: 'showVisitorDetails', 
    component: require('../components/Visitors/Detail').default,
    meta: {
      forusers: true,
      permission: 'read-user',
      breadcrumbs:[
      {
        text:'Dashboard',
        disabled:false,
        href:"/",
      },
      {
        text:'visitors',
        disabled:false,
        href:'/visitors',
      },
      {
        text: 'Visitor Details',
        disabled: true,
        href: '/visitors/:id'
      }
      ]
    }
  },
  { 
  path: '/visitors/edit/:id',
  name: 'editVisitor', 
  component: require('../components/Visitors/Edit').default,
  meta: {
    forusers: true,
    breadcrumbs:[
    {
      text:'Dashboard',
      disabled:false,
      href:'/'
    },
    {
        text: 'Visitors',
        disabled: false,
        href: '/visitors'
    },
    {
        text: 'Edit Visitor',
        disabled: true,
    },

    ]
    
  }
  },

  
  //Registration Routes
  { 
  path: '/registrations',
  name: 'registrations', 
  component: require('../components/Registrations/Index').default,
  meta: {
    forUsers: true,
    breadcrumbs: [
      {
        text: 'Dashboard',
        disabled: false,
        href: '/'
      },
      {
        text: 'Registrations',
        disabled: true,
        href: '/registrations'
      },
    ],
    
    }
  },
  { 
    path: '/addRegistration',
    name: 'addRegistration', 
    component: require('../components/Registrations/Create').default,
    meta: {
      forUsers: true,
      permission: 'read-booking',
      breadcrumbs:[
      {
        text:'Dashboard',
        disabled:false,
        href:"/",
      },
      {
        text:'Registrations',
        disabled:false,
        href:'/registrations',
      },
      {
        text: 'Add Registration',
        disabled: true,
        href: '/addRegistration'
      }
      ]
    }
  },
  { 
    path: '/registrations/:id',
    name: 'showRegistrationDetails', 
    component: require('../components/Registrations/Detail').default,
    meta: {
      forUsers: true,
      permission: 'read-office',
      breadcrumbs:[
      {
        text:'Dashboard',
        disabled:false,
        href:"/",
      },
      {
        text:'Registrations',
        disabled:false,
        href:'/registrations',
      },
      {
        text: 'Registration Details',
        disabled: true,
        href: '/registrations/:id'
      }
      ]
    }
  },
  { 
  path: '/registrations/edit/:id',
  name: 'editRegistration', 
  component: require('../components/Registrations/Edit').default,
  meta: {
    forusers: true,
    breadcrumbs:[
    {
      text:'Dashboard',
      disabled:false,
      href:'/'
    },
    {
        text: 'Registrations',
        disabled: false,
        href: '/registrations'
    },
    {
        text: 'Edit Registration',
        disabled: true,
    },

    ]
    
  }
  },
  //Visits Routes
  { 
  path: '/visits',
  name: 'visits', 
  component: require('../components/Visits/Index').default,
  meta: {
    forUsers: true,
    breadcrumbs: [
      {
        text: 'Dashboard',
        disabled: false,
        href: '/'
      },
      {
        text: 'Visits',
        disabled: true,
        href: '/visits'
      },
    ],
    
    }
  },
  { 
    path: '/visits/:id',
    name: 'showVisitDetails', 
    component: require('../components/Visits/Detail').default,
    meta: {
      forusers: true,
      permission: 'read-visit',
      breadcrumbs:[
      {
        text:'Dashboard',
        disabled:false,
        href:"/",
      },
      {
        text:'visits',
        disabled:false,
        href:'/visits',
      },
      {
        text: 'Visit Details',
        disabled: true,
        href: '/visits/:id'
      }
      ]
    }
  },
  //Office Routes
  { 
  path: '/offices',
  name: 'offices', 
  component: require('../components/Offices/Index').default,
  meta: {
    forUsers: true,
    breadcrumbs: [
      {
        text: 'Dashboard',
        disabled: false,
        href: '/'
      },
      {
        text: 'Offices',
        disabled: true,
        href: '/offices'
      },
    ],
    
    }
  },
  { 
    path: '/addOffice',
    name: 'addOffice', 
    component: require('../components/Offices/Create').default,
    meta: {
      forUsers: true,
      permission: 'read-booking',
      breadcrumbs:[
      {
        text:'Dashboard',
        disabled:false,
        href:"/",
      },
      {
        text:'Offices',
        disabled:false,
        href:'/offices',
      },
      {
        text: 'Add Office',
        disabled: true,
        href: '/addOffice'
      }
      ]
    }
  },
  { 
    path: '/offices/:id',
    name: 'showOfficeDetails', 
    component: require('../components/Offices/Detail').default,
    meta: {
      forUsers: true,
      permission: 'read-office',
      breadcrumbs:[
      {
        text:'Dashboard',
        disabled:false,
        href:"/",
      },
      {
        text:'Offices',
        disabled:false,
        href:'/offices',
      },
      {
        text: 'Office Details',
        disabled: true,
        href: '/offices/:id'
      }
      ]
    }
  },
  { 
    path: '/profile',
    name: 'profile', 
    component: require('../components/Offices/Profile').default,
    meta: {
      forUsers: true,
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/'
        },
        {
          text: 'Profile',
          disabled: true,
          href: '/profile'
        },
      ],
      
      }
    },
  { 
  path: '/offices/edit/:id',
  name: 'editOffice', 
  component: require('../components/Offices/Edit').default,
  meta: {
    forusers: true,
    breadcrumbs:[
    {
      text:'Dashboard',
      disabled:false,
      href:'/'
    },
    {
        text: 'Offices',
        disabled: false,
        href: '/offices'
    },
    {
        text: 'Edit Office',
        disabled: true,
    },

    ]
    
  }
  },
  { 
    path: '/profileEdit/:id',
    name: 'editProfile', 
    component: require('../components/Offices/ProfileEdit').default,
    meta: {
      forusers: true,
      breadcrumbs:[
      {
        text:'Dashboard',
        disabled:false,
        href:'/'
      },
      {
          text: 'Offices',
          disabled: false,
          href: '/offices'
      },
      {
          text: 'Edit Profile',
          disabled: true,
      },
  
      ]
      
    }
    },
  //Vendor Routes

  { 
  path: '/vendors',
  name: 'vendors', 
  component: require('../components/Vendors/Index').default,
  meta: {
    forUsers: true,
    breadcrumbs: [
      {
        text: 'Dashboard',
        disabled: false,
        href: '/'
      },
      {
        text: 'Vendors',
        disabled: true,
        href: '/vendors'
      },
    ],
    
    }
  },
  { 
    path: '/addVendor',
    name: 'addVendor', 
    component: require('../components/Vendors/Create').default,
    meta: {
      forUsers: true,
      permission: 'create-vendor',
      breadcrumbs:[
      {
        text:'Dashboard',
        disabled:false,
        href:"/",
      },
      {
        text:'Vendors',
        disabled:false,
        href:'/vendors',
      },
      {
        text: 'Add Vendor',
        disabled: true,
        href: '/addVendor'
      }
      ]
    }
  },
  { 
    path: '/vendors/:id',
    name: 'showVendorDetails', 
    component: require('../components/Vendors/Detail').default,
    meta: {
      forUsers: true,
      permission: 'read-vendor',
      breadcrumbs:[
      {
        text:'Dashboard',
        disabled:false,
        href:"/",
      },
      {
        text:'Vendors',
        disabled:false,
        href:'/vendors',
      },
      {
        text: 'Vendors Details',
        disabled: true,
        href: '/vendors/:id'
      }
      ]
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
